import React from 'react';
import { connect } from 'react-redux';
import {
  customerDetailRequest,
  customersRequest,
} from 'actions/customers/list';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import { formatDecimal, dateFormatter, rupiah } from 'utils/formatter';
import styles from './List.css';

class List extends React.Component {
  render() {
    const { customers, customerDetail } = this.props;

    return (
      <div className={styles['length-wrapper']}>
        {customers.length > 0 && (
          <div className={styles.wrapper}>
            <table className={styles['table-header']}>
              <thead>
                <tr>
                  <th className={`${styles.name}`}>Name</th>
                  <th className={`${styles['customer-since']}`}>
                    Customer Since
                  </th>
                  <th className={`${styles['member-since']}`}>Member Since</th>
                  <th className={`${styles.points}`}>Points</th>
                  <th className={`${styles.lifetime}`}>Lifetime Spending</th>
                </tr>
              </thead>
            </table>
            <div
              className={`${
                styles['table-content-wrapper']
              } customers-list-table-content-wrapper`}
            >
              <InfiniteScroll
                pageStart={1}
                loadMore={this._onReachBottom}
                hasMore={this._hasMore()}
                useWindow={false}
                threshold={10}
                initialLoad={false}
              >
                <table className={styles['table-content']}>
                  <tbody>
                    {customers.map(customer => {
                      return (
                        <tr
                          key={customer.id}
                          className={`${
                            customerDetail && customer.id === customerDetail.id
                              ? styles.selected
                              : ''
                          }`}
                          onClick={() => this._onClickRow(customer)}
                        >
                          <td className={`${styles.name}`}>
                            {customer.name || customer.email || customer.phone}
                          </td>
                          <td className={`${styles['customer-since']}`}>
                            {customer.member_since}
                          </td>
                          <td className={`${styles['member-since']}`}>
                            {customer.loyalty_member_since
                              ? dateFormatter(customer.loyalty_member_since)
                              : ''}
                          </td>
                          <td className={`${styles.points}`}>
                            {customer.loyalty_point !== null
                              ? formatDecimal(customer.loyalty_point)
                              : ''}
                          </td>
                          <td className={`${styles.lifetime}`}>
                            {rupiah(customer.lifetime_total)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        )}
        {customers.length === 0 && (
          <NoDataDisplay
            title="No Data to Display"
            classPath="no-data-without-description"
          />
        )}
      </div>
    );
  }

  _onClickRow = customer => {
    this.props.dispatch(
      customerDetailRequest(customer, { type: this.props.type })
    );
    this.props.showDetail();
  };

  _onReachBottom = () => {
    this.props.closeDetail();
    const { customers, currentPage, dispatch, keyword, type } = this.props;
    dispatch(
      customersRequest({ page: currentPage + 1, keyword, type }, customers)
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };
}

List.propTypes = {
  customers: PropTypes.array,
  customerDetail: PropTypes.object,
  dispatch: PropTypes.func,
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
  keyword: PropTypes.string,
};

function mapStateToProps(state) {
  const {
    customers,
    customerDetail,
    currentPage,
    totalPage,
    keyword,
    type,
  } = state.customers.list;
  return { customers, customerDetail, currentPage, totalPage, keyword, type };
}

export default connect(mapStateToProps)(List);
